/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_HelperInputs */

const es_components_buy_messages_modal_custom_helper = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El precio por mensaje para cantidades personalizadas puede ser levemente superior a los packs predefinidos.`)
};

const en_components_buy_messages_modal_custom_helper = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The price per message for custom amounts may be slightly higher than predefined packs.`)
};

/**
* | output |
* | --- |
* | "The price per message for custom amounts may be slightly higher than predefined packs." |
*
* @param {Components_Buy_Messages_Modal_Custom_HelperInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_helper = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_HelperInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_HelperInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_helper(inputs)
	return en_components_buy_messages_modal_custom_helper(inputs)
});
export { components_buy_messages_modal_custom_helper as "components.buy_messages_modal.custom.helper" }